import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { Button } from "primereact/button";
import { apiRequest } from "../Auth/AuthConfig";

const Logout = () => {
  const location = useLocation();
  const { instance } = useMsal();
  const [isEmbedded, setIsEmbedded] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkIfEmbedded = () => {
      const searchParams = new URLSearchParams(location.search);
      const embeddingParam =
        searchParams.get("embedding") || searchParams.get("embedded");

      const isInIframe = (() => {
        try {
          return window.self !== window.top;
        } catch {
          return true;
        }
      })();

      return (
        location.pathname.toLowerCase().includes("/embedding") ||
        embeddingParam === "true" ||
        embeddingParam === "1" ||
        isInIframe
      );
    };

    setIsEmbedded(checkIfEmbedded());
  }, [location]);

  const handleLogin = async () => {
    setLoading(true);

    try {
      const response = await instance.loginPopup(apiRequest);

      if (response.account) {
        instance.setActiveAccount(response.account);
      }

      window.location.reload();
    } catch (error) {
      console.error("Login failed:", error);
      window.open(window.location.origin, "_blank");
    } finally {
      setLoading(false);
    }
  };

  if (isEmbedded) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100%",
          backgroundColor: "var(--surface-ground)",
        }}
      >
        <Button
          label="Login to Continue"
          icon="pi pi-sign-in"
          onClick={handleLogin}
          loading={loading}
          className="p-button-primary rounded"
        />
      </div>
    );
  }

  return <div><h1>logout</h1></div>;
};

export default Logout;